export const GET_ALERTS = 'sagas/alert/GET_ALERTS';
export const GET_ALERTS_BY_CAUSE = 'sagas/alert/GET_ALERT';
export const SET_ALERTS_BY_CAUSE = 'sagas/alert/SET_ALERT';
